import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class DriverRoundDifferencePouchOperationFilterEntity {
  fromPouchId?: number
  toPouchId?: number
  date?: string[]
  region?: RegionMiniEntity
  page?: number
  limit?: number
}
